<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra">
    <!-- <div class="alert alert-primary mx-3" role="alert" *ngIf="alert">
        A simple primary alert—check it out!
    </div> -->

    <div class="row  ps-3">
      <div class="col pt-3 ">
        <p> <span class="fw-bold">Pembayar Cukai</span> - e-Borang </p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5 ">
        <p class="text-muted">Sila pilih jenis carian iaitu TIN, No Pengenalan atau No. Pendaftaran (ROC).</p>
      </div>
    </div>
    <div class="row pb-5">
      <div class="col-3 ms-5">
        <select class="form-select border-0 shadow" aria-label="Search type" [(ngModel)]="SearchTypeInput" [ngModelOptions]="{standalone: true}" (change)="onChangeIDType()">
          <option value="" selected>Jenis Carian</option>
          <option value="1">MyKad/MyPR/MyKAS</option>
          <option value="2">No. Pasport/Dokumen lain</option>
          <!-- <option value="3">Tentera</option>
          <option value="4">Polis</option> -->
          <option value="5">No. Pendaftaran</option>
          <option value="6">TIN (Selain No. Majikan)</option>
          <option value="7">TIN (Majikan)</option>
          <!--<option value="6">No. Pendaftaran (ROC)</option>-->
        </select>
      </div>
      <div class="col-3" *ngIf="SearchTypeInput === '6' || SearchTypeInput === '7'">
        <input type="number" class="form-control border-0 shadow" [(ngModel)]="ValueInput" [ngModelOptions]="{standalone: true}">
      </div>
      <div class="col-3" *ngIf="SearchTypeInput !== '6' && SearchTypeInput !== '7'">
        <input type="text" class="form-control border-0 shadow" [(ngModel)]="ValueInput" [ngModelOptions]="{standalone: true}">
      </div>
      <div class="col-5">
        <div class="btn-toolbar d-flex justify-content-center">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Submit(SearchTypeInput,ValueInput)">Hantar</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2 bg-white" role="button" (click)="Semula()">Semula</button>
          </div>
          <!--<div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2 bg-white" role="button" (click)="openNewTab()">CP8D</button>
          </div>-->


        </div>
      </div>
    </div>
    <div class="accordion px-5 pb-5" id="resultAcordion" *ngIf="SearchStatus">
      <div class="accordion-item border-0">
        <h2 class="accordion-header m-0" id="headingOne">
          <button class="accordion-button primary-colour text-black shadow rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            Butiran Carian
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse show bottom-page-shadow default-content-bg-colour rounded-bottom-extra" aria-labelledby="headingOne" data-bs-parent="#resultAcordion">
          <div class="accordion-body">
            <div class="row">
              <div class="col-2">
                <p>Pembayar Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-5">
                <p><strong>{{Name}}</strong></p>
              </div>
            </div>

            <div class="row" *ngIf="SearchByTINStatus">
              <div class="col-2">
                <p>TIN</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-1">
                <p><strong>{{IT_REF_NO}}</strong></p>
              </div>
            </div>

            <div class="row" *ngIf="SearchByIDNoStatus">
              <div class="col-2">
                <p>No. Pengenalan / No. Pendaftaran</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-1">
                <p><strong>{{IDNo}}</strong></p>
              </div>
            </div>

            <div class="row" [ngClass]="IDType === '0' ? '' : 'd-none' ">
              <div class="col-2">
                <p>No. Pendaftaran (ROC) </p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-1">
                <p><strong>{{IDNo}}</strong></p>
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <p>LHDNM / Cawangan Khas</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-3">
                <p><strong>{{BranchName}}</strong></p>
              </div>
            </div>

            <div class="row" [ngClass]="TaxAgentID !== '' ? '' : 'd-none'">
              <div class="col-2">
                <p>Ejen Cukai Dilantik </p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-4">
                <p><strong>{{TaxAgentName}}</strong></p>
              </div>
            </div>

            <div class="row pt-3" *ngIf="RegisterFormAccess">
              <div class="col-2">
                <select class="form-select border-0 shadow" [(ngModel)]="FormTypeInput" [ngModelOptions]="{standalone: true}" (change)="ChangeFormTypeRegister(FormTypeInput)">
                  <option value="">Jenis Borang</option>
                  <option *ngFor="let res of FormTypeList" [value]="res.formDisplayName">e-{{res.formDisplayName}}</option>
                </select>
              </div>
              <div class="col-2" *ngIf="YearAssessmentRegisterStatus">
                <ng-container>
                  <select class="form-select border-0 shadow" [(ngModel)]="YearAssessmentInput" [ngModelOptions]="{standalone: true}">
                    <option value="">Tahun Taksiran</option>
                    <option *ngFor="let res of YearAssessmentList" [value]="res">{{res}}</option>
                  </select>
                </ng-container>
              </div>
              <div class="col-4" [ngClass]="TaxAgentID === '' ? '' : 'd-none'">
                <select class="form-select border-0 shadow" [(ngModel)]="AgentInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Ejen Cukai</option>
                  <option *ngFor="let res of AgentList" [value]="res.taxAgentID">{{res.taxAgentName}}</option>
                </select>
              </div>
              <div class="col-2">
                <div class="btn-toolbar d-flex justify-content-center">
                  <div class="me-2">
                    <button type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="RegisterForm(FormTypeInput,YearAssessmentInput,AgentInput,IT_REF_NO)">Daftar</button>
                  </div>
                </div>
              </div>
            </div>


            <div class="pt-5">
              <p>Senarai Borang Didaftar Firma</p>
              <!--<input #input type="text" (keyup)="applyFilter($event)" class="form-control w-25 mb-2 border-0 shadow" placeholder="Carian" aria-label="Carian" aria-describedby="basic-addon1">-->
            </div>
            <div class="example-table-container">
              <table mat-table [dataSource]="dataSource" class="w-100 shadow">
                <ng-container matColumnDef="jenisborang">
                  <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Jenis Borang</th>
                  <td class="text-center" mat-cell *matCellDef="let res">{{res.nama_Borang}}</td>
                </ng-container>
                <ng-container matColumnDef="staffname">
                  <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Staf</th>
                  <td class="text-center" mat-cell *matCellDef="let res">{{res.staffName}}</td>
                </ng-container>
                <ng-container matColumnDef="agentname">
                  <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Ejen Cukai</th>
                  <td class="text-center" mat-cell *matCellDef="let res">{{res.agentName}}</td>
                </ng-container>
                <ng-container matColumnDef="tarikhdaftar">
                  <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Daftar</th>
                  <td class="text-center" mat-cell *matCellDef="let res">{{res.dateRegister}}</td>
                </ng-container>
                <ng-container matColumnDef="tarikhhantar">
                  <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Hantar</th>
                  <td class="text-center" mat-cell *matCellDef="let res">{{res.dateSubmit}}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
                  <td mat-cell *matCellDef="let res">
                    <div class="btn-toolbar d-flex justify-content-center">
                      <div class="me-2" *ngIf="res.distributeAccess">
                        <button type="button" (click)="Distribute(res.taxReturnForm_ID,res.userID,Name, res.jenis_Borang, res.agentID, res.staffName, IT_REF_NO, res.dateRegister, res.nama_Borang)" class="btn sec-button border-0 shadow rounded-2" role="button" data-bs-toggle="modal" data-bs-target="#agihSemulaModal">Agih Semula</button>
                      </div>
                      <div class="me-2" *ngIf="res.acknowledgementAccess && (res.jenis_Borang != 'CP22' && res.jenis_Borang != 'CKM')">
                        <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="GetAcknowledment(res.jenis_Borang,res.formYear,IT_REF_NO)">Semakan</button>
                      </div>
                      <div class="me-2" *ngIf="res.jenis_Borang == 'CKM'">
                        <button type="button" class="btn sec-button border-0 shadow rounded-2" data-bs-toggle="modal" data-bs-target="#ckmSemakanModal" role="button">Semakan</button>
                      </div>
                      <div class="me-2" *ngIf="res.jenis_Borang == 'CP22'">
                        <button type="button" class="btn sec-button border-0 shadow rounded-2" data-bs-toggle="modal" data-bs-target="#cp22SemakanModal" role="button">Semakan</button>
                      </div>
                      <div class="me-2" *ngIf="res.resetAccess">
                        <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" data-bs-toggle="modal" data-bs-target="#setSemulaModal" (click)="ResetFormValue(IT_REF_NO,res.jenis_Borang,res.formYear)">Set Semula</button>
                      </div>
                      <div class="me-2" *ngIf="res.loginAccess">
                        <button type="button" (click)="LoginForm(res.taxReturnForm_ID,res.jenis_Borang)" class="btn sec-button border-0 shadow rounded-2" role="button">Login</button>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let test;columns:displayedColumns"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell text-center" colspan="10">Tiada Rekod</td>
                </tr>
              </table>
              <!--<mat-paginator class="mat-evelation-z8" (page)="paginatorEvent($event)" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10,15,20]" [length]="RecordCount">
    </mat-paginator>-->
            </div>

            <div>
              <p>Senarai Borang Bukan Didaftar Firma</p>



              <!--<input #input type="text" (keyup)="applyFilter($event)" class="form-control w-25 mb-2 border-0 shadow" placeholder="Carian" aria-label="Carian" aria-describedby="basic-addon1">-->
            </div>
            <div class="example-table-container">
              <table mat-table [dataSource]="dataSourceOtherFirm" class="w-100 shadow">
                <ng-container matColumnDef="jenisborang">
                  <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Jenis Borang</th>
                  <td class="text-center" mat-cell *matCellDef="let res">{{res.nama_Borang}}</td>
                </ng-container>
                <ng-container matColumnDef="tarikhdaftar">
                  <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Daftar</th>
                  <td class="text-center" mat-cell *matCellDef="let res">{{res.dateRegister}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsOtherFirm; sticky: true"></tr>
                <tr mat-row *matRowDef="let test;columns:displayedColumnsOtherFirm"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell text-center" colspan="10">Tiada Rekod</td>
                </tr>
              </table>
              <!--<mat-paginator class="mat-evelation-z8" (page)="paginatorEvent($event)" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10,15,20]" [length]="RecordCount">
    </mat-paginator>-->
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>



</div>


<iframe [src]="trustedURL" width="80%" height="1000px"></iframe>
<!-- Set Semula Modal -->
<div class="modal fade" id="setSemulaModal" tabindex="-1" aria-labelledby="setSemulaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="background-color: rgba(223, 224, 224, 0.9);border-radius: 1.7rem !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-center align-items-center">
          <img src="./assets/icons/paper-pencil-yellow-circle.svg" height="90" width="90" alt="..." />
        </div>
        <p class="fw-bold text-center">Adakah anda pasti untuk membuat Set Semula?</p>
        <div class="d-flex justify-content-center align-items-center pb-3 pt-3">
          <div class="d-block">
            <button class="btn button-white-table shadow" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Tidak</button>
            <button class="btn button-white-table shadow mx-3" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal" (click)="ResetForm(TaxRefNumResetForm,FormTypeResetForm,YearAssessmentResetForm)">Ya</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Semakan Modal -->
<!--<div class="modal fade" id="semakanModal" tabindex="-1" aria-labelledby="semakanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="background-color: rgba(223, 224, 224, 0.9);border-radius: 1.7rem !important;">
      <div class="modal-body">-->
<!-- <div class="d-flex justify-content-end align-items-end">
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div> -->
<!--<div class="d-flex justify-content-center align-items-center">
          <img src="./assets/icons/paper-pencil-yellow-circle.svg" height="90" width="90" alt="..." />
        </div>
        <p class="fw-bold text-center">Adakah anda pasti untuk membuat Semakan?</p>
        <div class="d-flex justify-content-center align-items-center pb-3 pt-3">
          <div class="d-block">
            <button class="btn button-white-table shadow" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Tidak</button>
            <button class="btn button-white-table shadow mx-3" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Ya</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>-->
<!-- Agih Semula Modal -->
<div class="modal fade" id="agihSemulaModal" tabindex="-1" aria-labelledby="agihSemulaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Agih Semula</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <div class="row">
              <div class="col-2">
                <p>Pembayar Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p><strong>{{TaxpayerNameView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Jenis Borang</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p><strong>{{FormTypeView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Nama Staf</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{StaffNameView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>TIN</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{TaxpayerRefNumView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Tarikh Daftar</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{RegisterDateView}}</strong></p>
              </div>
            </div>
            <div class="row py-5">
              <div class="col-2">
                <p>Agih Kepada</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <select class="form-select border-0 shadow" [(ngModel)]="DistributeInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Senarai Staf</option>
                  <option *ngFor="let res of DistributeList" [value]="res.staffID">{{res.staffName}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex justify-content-end align-items-end">
                <div class="btn-toolbar">
                  <div class="me-2">
                    <button data-bs-dismiss="modal" (click)="DistributeSubmit(TaxReturnFormIDView,DistributeInput,TaxAgentIDView,TaxpayerRefNumView,FormTypeView)" type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button">Agih Semula</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>


<!-- CP8D Modal -->
<!--<div class="modal fade" id="CP8DModal" tabindex="-1" aria-labelledby="CP8DModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content modal-height">
      <div class="modal-header">
        <h5 class="modal-title" id="CP8DModalLabel">Dokumen Sokongan</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="height: 100%;">
        <iframe width="100%" height="100%" frameborder="0" [src]="urlSafe"></iframe>
      </div>
    </div>
  </div>
</div>-->
<!-- CKM Acknowledgement Modal -->
<div class="modal fade" id="ckmSemakanModal" tabindex="-1" aria-labelledby="ckmSemakanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>
        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>CKM Semakan pengesahan</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <div class="row py-5">
              <div class="col-3">
                <p>Tahun Taksiran</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-4">
                <select class="form-select border-0 shadow" [(ngModel)]="CKMYearAssessmentInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Tahun</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex justify-content-end align-items-end">
                <div class="btn-toolbar">
                  <div class="me-2">
                    <button data-bs-dismiss="modal" type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="GetAcknowledment('CKM',CKMYearAssessmentInput,IT_REF_NO)">Hantar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- CP22 Acknowledgement Modal -->
<div class="modal fade" id="cp22SemakanModal" tabindex="-1" aria-labelledby="cp22SemakanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>
        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>CP22 Semakan pengesahan</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <div class="row py-5">
              <div class="col-3">
                <p>Tahun</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-4">
                <select class="form-select border-0 shadow" [(ngModel)]="CP22YearAssessmentInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Tahun</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex justify-content-end align-items-end">
                <div class="btn-toolbar">
                  <div class="me-2">
                    <button data-bs-dismiss="modal" type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="GetAcknowledment('CP22',CP22YearAssessmentInput,IT_REF_NO)">Hantar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
